import React from 'react';
import { Product } from '../store/slices/productsSlice';

interface ProductTooltipProps {
  product: Product;
  show: boolean;
  position: { x: number; y: number };
}

const ProductTooltip: React.FC<ProductTooltipProps> = ({ product, show, position }) => {
  if (!show) return null;

  const formatValue = (value: any) => {
    if (value === null || value === undefined) return '-';
    return String(value);
  };

  return (
    <div 
      className="product-tooltip"
      style={{
        position: 'fixed',
        left: position.x + 10,
        top: position.y - 10,
        zIndex: 1000,
        pointerEvents: 'none'
      }}
    >
      <div className="tooltip-content">
        <div className="tooltip-header">
          <h6 className="mb-2">{product.name}</h6>
        </div>
        
        <div className="tooltip-body">
          {/* Артикул */}
          {product.article && (
            <div className="tooltip-section mb-3">
              <h6 className="section-title">Артикул</h6>
              <div className="tooltip-item">
                <span className="label">Код:</span>
                <span className="value badge bg-info text-white">{product.article}</span>
              </div>
            </div>
          )}

          {/* Продажи и производительность */}
          <div className="tooltip-section mb-3">
            <h6 className="section-title">Продажи и производительность</h6>
            <div className="tooltip-grid">
              <div className="tooltip-item">
                <span className="label">Продажи:</span>
                <span className="value">{formatValue(product.stat_sales)}</span>
              </div>
              <div className="tooltip-item">
                <span className="label">Комментарии:</span>
                <span className="value">{formatValue(product.stat_comments_count)}</span>
              </div>
              <div className="tooltip-item">
                <span className="label">Оценка:</span>
                <span className="value">{formatValue(product.stat_comments_valuation)}</span>
              </div>
              <div className="tooltip-item">
                <span className="label">Средние продажи:</span>
                <span className="value">{formatValue(product.stat_average_if_in_stock)}</span>
              </div>
              <div className="tooltip-item">
                <span className="label">Процент выкупа:</span>
                <span className="value">{formatValue(product.stat_purchase_percent)}</span>
              </div>
            </div>
          </div>

          {/* Информация о продавце */}
          {product.seller_name && (
            <div className="tooltip-section">
              <h6 className="section-title">Продавец</h6>
              <div className="tooltip-item">
                <span className="label">Название:</span>
                <span className="value">{formatValue(product.seller_name)}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductTooltip;
